"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActiveMembersQueryParamsSchema = exports.MemberAcquisitionSnapshotBaseSchema = exports.MembersEvolutionGroupBy = exports.MembersDashboardStatsSchema = exports.ChartDataPointSchema = exports.ActiveMemberSchema = void 0;
var zod_1 = require("zod");
exports.ActiveMemberSchema = zod_1.z.object({
    UserId: zod_1.z.string(),
    fullName: zod_1.z.string(),
    email: zod_1.z.string(),
    membershipType: zod_1.z.string(),
    expireDate: zod_1.z.string(), // Formatted as DD/MM/YYYY
    automaticRenewal: zod_1.z.boolean().nullable(),
});
exports.ChartDataPointSchema = zod_1.z.object({
    label: zod_1.z.string(),
    value: zod_1.z.number(),
});
exports.MembersDashboardStatsSchema = zod_1.z.object({
    totalActiveMembers: zod_1.z.number(),
    totalOtherUsers: zod_1.z.number(),
    nonMembers: zod_1.z.number(),
    partners: zod_1.z.number(),
    honorary: zod_1.z.number(),
    membersByType: zod_1.z.array(exports.ChartDataPointSchema),
    autoRenewalOffCount: zod_1.z.number(),
    autoRenewalOnCount: zod_1.z.number(),
    autoRenewalUnknownCount: zod_1.z.number(),
    autoRenewalOffExpiringSoonCount: zod_1.z.number(),
});
// Group by options for Members evolution chart
exports.MembersEvolutionGroupBy = {
    MEMBER_TYPE: 'memberType',
    ACQUISITION_TYPE: 'acquisitionType',
};
exports.MemberAcquisitionSnapshotBaseSchema = zod_1.z.object({
    snapshotDate: zod_1.z.coerce.date(), // First day of month (e.g., 2024-01-01)
    acquisitionType: zod_1.z.string(), // "New", "Renewed", "Existing"
    count: zod_1.z.number(), // Count for this type
    totalCount: zod_1.z.number(), // Total active members (all types)
});
exports.ActiveMembersQueryParamsSchema = zod_1.z.object({
    searchQuery: zod_1.z.string().optional(),
    membershipType: zod_1.z.string().optional(),
    automaticRenewal: zod_1.z.enum(['true', 'false']).optional(),
    skip: zod_1.z.number().default(0),
    limit: zod_1.z.number().default(10),
    sortField: zod_1.z.string().optional(),
    sortDirection: zod_1.z.number().optional(),
});
//# sourceMappingURL=MembersDashboard.js.map